import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownWithCodeDTO } from "../../../types/common/DropdownWithCodeDTO";

interface PdfTypeState {
  pdfTypeDropdown: DropdownWithCodeDTO[];
}

const initialState: PdfTypeState = {
  pdfTypeDropdown: [],
};

export const pdfTypeSlice = createSlice({
  name: "pdfType",
  initialState,
  reducers: {
    loadingPdfTypeDropdown: (state, action: PayloadAction<DropdownWithCodeDTO[]>) => {
      state.pdfTypeDropdown = action.payload;
    },
  },
});

export const { loadingPdfTypeDropdown } = pdfTypeSlice.actions;
export default pdfTypeSlice.reducer;
